export interface RegisterIdentifyModel {
  email: string
  backOfficeCompanyId: string
  legalId: string
}

export enum RegisterOrigin {
  unknownOrigin = 0,
  ManagerWithRoleAccountCreation = 1, // From profile creation
  SelfAccountCreation = 2, // From website registration
  BackofficeAccountCreation = 3, // From TRI creation
}
